import React from "react";

const Footer = () => (
  <div className="app-footer">
    <p>© Provolve IT | Easy Software Deployment Package Store</p>
  </div>
);

export default Footer;
